module.exports = __webpack_public_path__ + "img/6.b711b4aa.png";